export default __webpack_public_path__ + "static/media/V360_RoHS.403a1db1.pdf";